import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useProducts } from "../hooks/useProducts";

const scrollToPricing = () => {
  document
    .getElementById("pricing")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};

/**
 * Sticky bar pinned to the top of the landing page that surfaces the yearly
 * discount the moment a visitor lands. Renders nothing until the discount is
 * known so the headline figure is always real.
 */
const PromoBar: React.FC = () => {
  const { savingsPercentage } = useProducts();
  const show = savingsPercentage > 0;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="sticky top-0 z-50 overflow-hidden"
        >
          <button
            type="button"
            onClick={scrollToPricing}
            className="group relative w-full overflow-hidden bg-gradient-to-r from-[#47b3fe] via-indigo-600 to-purple-600 text-white"
          >
            {/* Animated sheen */}
            <span className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 -skew-x-12 bg-white/20 blur-md transition-transform duration-700 group-hover:translate-x-[400%]" />

            <span className="relative flex items-center justify-center gap-2 px-4 py-2.5 text-center text-[13px] font-semibold sm:text-sm">
              <i className="fas fa-fire text-amber-300" />
              <span>
                Limited time —{" "}
                <span className="font-extrabold">
                  save {savingsPercentage}%
                </span>{" "}
                on the Yearly plan
              </span>
              <span className="ml-1 hidden items-center gap-1 rounded-full bg-white/20 px-3 py-0.5 text-xs font-bold transition-colors group-hover:bg-white/30 sm:inline-flex">
                Claim now
                <i className="fas fa-arrow-right text-[10px] transition-transform group-hover:translate-x-0.5" />
              </span>
            </span>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PromoBar;
